import api from "./api";

// Capa de servicios API del dominio "solicitudes web" (doc 0398).
// Wrappers de transporte finos: el endpoint en un único sitio, la construcción
// de params en el componente — mismo criterio que appointments.api.js.

export const listWebLeads = (params) => api.get("/web-leads", { params });

export const updateWebLeadStatus = (id, status) =>
  api.patch(`/web-leads/${id}/status`, { status });
